import { UPDATE_WHATSAPP_NOTIFICATION_REQUEST, UPDATE_WHATSAPP_NOTIFICATION_SUCCESS, UPDATE_WHATSAPP_NOTIFICATION_FAILURE, UPDATE_WHATSAPP_NOTIFICATION_RESET, } from "../../actions";
const initialState = {
    updateData: {},
    isLoading: false,
    error: null,
};
const UpdateWhatsappNotificationreducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_WHATSAPP_NOTIFICATION_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case UPDATE_WHATSAPP_NOTIFICATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateData: action.payload, isLoading: false, error: null });
        case UPDATE_WHATSAPP_NOTIFICATION_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case UPDATE_WHATSAPP_NOTIFICATION_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, updateData: null, error: null });
        default:
            return state;
    }
};
export default UpdateWhatsappNotificationreducer;
